import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollScaleData  {
    _originalTypeClassName = "zERP.BO.PayrollScaleData";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollScaleData.translate = translateService;
}
this.Items = [];
this.ChildrenDiscounts = [];
this.Id = null;
this.Code = null;
this.ActiveFrom = null;
this.IsTiered = false;
this.ValueType = null;
this.Version = null;
this.DiscountLimit = null;
this.DiscountLimitReducePercentage = null;
this.GeneralDiscountPerChild = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
ActiveFrom:any;
IsTiered:any;
ValueType:any;
Version:any;
DiscountLimit:any;
DiscountLimitReducePercentage:any;
GeneralDiscountPerChild:any;
Items:any;
ChildrenDiscounts:any;
PayrollVariable:any;
Scale:any;
static setItems = ($this, items) => {
                if (items == null) items = [];
                if ($this.Items == null) $this.Items = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Items.length > 0) {
                    Domain.PayrollScaleData.removeItems($this, $this.Items[0]);
                }

                Domain.PayrollScaleData.addManyItems($this, copyItems);
            }
static addManyItems = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollScaleData.addItems($this, items[i]);
                }
            }
static addItems = ($this, item) => {
                if ($this.Items == null) $this.Items = [];
                if (item == null || $this.Items.indexOf(item) > -1) return;
                $this.Items.push(item);
}
static addRangeItems = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollScaleData.addItems($this, item));
            }
static removeItems = ($this, item) => {
                if ($this == null || $this.Items == null || $this.Items.indexOf(item) === -1) return;
                var _index = $this.Items.indexOf(item);
                $this.Items.splice(_index, 1);
}
static clearItems = ($this) => { $this.Items = null; }
static setChildrenDiscounts = ($this, items) => {
                if (items == null) items = [];
                if ($this.ChildrenDiscounts == null) $this.ChildrenDiscounts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ChildrenDiscounts.length > 0) {
                    Domain.PayrollScaleData.removeChildrenDiscounts($this, $this.ChildrenDiscounts[0]);
                }

                Domain.PayrollScaleData.addManyChildrenDiscounts($this, copyItems);
            }
static addManyChildrenDiscounts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PayrollScaleData.addChildrenDiscounts($this, items[i]);
                }
            }
static addChildrenDiscounts = ($this, item) => {
                if ($this.ChildrenDiscounts == null) $this.ChildrenDiscounts = [];
                if (item == null || $this.ChildrenDiscounts.indexOf(item) > -1) return;
                $this.ChildrenDiscounts.push(item);
}
static addRangeChildrenDiscounts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PayrollScaleData.addChildrenDiscounts($this, item));
            }
static removeChildrenDiscounts = ($this, item) => {
                if ($this == null || $this.ChildrenDiscounts == null || $this.ChildrenDiscounts.indexOf(item) === -1) return;
                var _index = $this.ChildrenDiscounts.indexOf(item);
                $this.ChildrenDiscounts.splice(_index, 1);
}
static clearChildrenDiscounts = ($this) => { $this.ChildrenDiscounts = null; }
static setPayrollVariable = ($this, value) => {
var oldValue = $this.PayrollVariable;
$this.PayrollVariable = value;
if (value != null) {
}
}
static setScale = ($this, value) => {
var oldValue = $this.Scale;
$this.Scale = value;
if (value != null) {
if (oldValue != null) {
Domain.PayrollScale.removeVersions(oldValue, $this);
}
Domain.PayrollScale.addVersions(value, $this);
}
}

static Calculate($this: any, payroll: any,manualInput: any,logSection: any): any{if (CLMS.Framework.Number.Equal(() => $this.Items.length, () => 0)) {if (logSection != null) {Domain.TaskLogSection.AddMessage(logSection, Domain.TaskResultMessageSeverity.Info, "no items returning 0");}return 0;}
if ($this?.ValueType == Domain.PayrollScaleValueType.PayrollCategory) {return Domain.PayrollScaleData.CalculateValueBasedOnCategory($this, payroll, logSection);}
let paramValue = 0;
if ($this?.Scale?.SystemicType == Domain.PayrollScaleSystemicType.FMY) {$this.ValueType = Domain.PayrollScaleValueType.ManualInput;}
switch ($this?.ValueType) {case Domain.PayrollScaleValueType.NumberOfChildren:
{
paramValue = Joove.Common.cast(Domain.EmployeePayroll.GetVariableValue(payroll, Domain.CalculatedExpressionParameterDefinition.GetNumberOfChildrenInputKey()), "number");break;
}
case Domain.PayrollScaleValueType.WorkExpirience:
{
paramValue = Joove.Common.cast(Domain.EmployeePayroll.GetVariableValue(payroll, Domain.CalculatedExpressionParameterDefinition.GetWorkExpirienceInputKey()), "number");break;
}
case Domain.PayrollScaleValueType.ManualInput:
{
paramValue = ($this?.Scale?.SystemicType == Domain.PayrollScaleSystemicType.FMY ? manualInput : Domain.EmployeePayroll.GetVariableValue(payroll, $this?.PayrollVariable?.Code));break;
}
default:
{
throw Error("Payroll Scale value type '" + $this?.ValueType + "' is not implemented");}
}
if (logSection != null) {Domain.TaskLogSection.AddMessage(logSection, Domain.TaskResultMessageSeverity.Info, "Scale parameter value: " + Joove.Common.safeNumber(paramValue));}
return Domain.PayrollScaleData.CalculateScaleValue($this, paramValue, $this?.Items, logSection);
}
static CalculateFMY2026Scales($this: any, employeePayroll: any,taxAnnualAmount: any,logSection: any): any{let lst_scaleItems = [];
lst_scaleItems?.addRange($this?.Items);
let childrenCount = employeePayroll?.Contract?.Employee?.ChildrenCount;
let age = Domain.PayrollScaleData.calculateFMYAgeEmployee(employeePayroll);
for (let _iscale = 0; _iscale < ($this?.Items == null ? 0 : $this?.Items.length); _iscale++) {let scale = $this?.Items[_iscale];if (CLMS.Framework.Number.Equal(() => scale.ValueFrom, () => 0)) {if (CLMS.Framework.Number.GreaterThanOrEqual(() => childrenCount, () => 4) || CLMS.Framework.Number.LessThanOrEqual(() => age, () => 25)) {scale.Value = 0;continue;}if (CLMS.Framework.Number.GreaterThan(() => age, () => 25) && CLMS.Framework.Number.LessThanOrEqual(() => age, () => 30)) {scale.Value = 9;continue;}else {scale.Value = 9;continue;}}else if (CLMS.Framework.Number.Equal(() => scale.ValueFrom, () => 10000)) {if (CLMS.Framework.Number.GreaterThanOrEqual(() => childrenCount, () => 4) || CLMS.Framework.Number.LessThanOrEqual(() => age, () => 25)) {scale.Value = 0;continue;}if (CLMS.Framework.Number.GreaterThan(() => age, () => 25) && CLMS.Framework.Number.LessThanOrEqual(() => age, () => 30)) {scale.Value = 9;continue;}switch (childrenCount) {case 0:
{
scale.Value = 20;break;}
case 1:
{
scale.Value = 18;break;}
case 2:
{
scale.Value = 16;break;}
case 3:
{
scale.Value = 9;break;}
}}else if (CLMS.Framework.Number.Equal(() => scale.ValueFrom, () => 20000)) {let childrenModifyScaleValue = Joove.Common.safeNumber(26) - Joove.Common.safeNumber(2) * Joove.Common.safeNumber(childrenCount);scale.Value = (CLMS.Framework.Number.GreaterThanOrEqual(() => childrenModifyScaleValue, () => 0) ? childrenModifyScaleValue : 0);}else {break;}}
let yearlyTax = Domain.PayrollScaleData.Calculate($this, employeePayroll, taxAnnualAmount, logSection);
$this?.Items?.splice(0, $this?.Items.length);
$this?.Items?.addRange(lst_scaleItems);
return yearlyTax;
}
static calculateFMYAgeEmployee(emp: any): any{let taxYear = 2026;
let dob = emp?.Employee?.DateOfBirth;
let yearEnd = moment([taxYear, (1) - 1, 1]).toDate();
let age = Joove.Common.safeNumber(moment(yearEnd).year()) - Joove.Common.safeNumber(moment(dob).year());
let yearEndFMY = moment([Joove.Common.safeNumber(taxYear) - Joove.Common.safeNumber(age), (1) - 1, 1]).toDate();
if (((new Date(dob).getTime()) > (new Date(yearEndFMY).getTime()))) {age = Joove.Common.safeNumber(age) - Joove.Common.safeNumber(1);}
return age;
}
static CalculateScaleValue($this: any, paramValue: any,originalItems: any,logSection: any): any{let items = originalItems?.linq?.orderBy((o) => o?.ValueFrom)?.toArray();
let currentScale = items?.linq?.where()?.firstOrDefault(null);
if ($this?.IsTiered) {let remaining = paramValue;let currentIndex = 0;let total = 0;console.warn("remaining " + Joove.Common.safeNumber(remaining));while (CLMS.Framework.Number.GreaterThan(() => remaining, () => 0)) {let next = ((CLMS.Framework.Number.GreaterThan(() => items.length, () => Joove.Common.safeNumber(currentIndex) + Joove.Common.safeNumber(1))) ? items[Joove.Common.safeNumber(currentIndex) + Joove.Common.safeNumber(1)] : null);let ammoutToCalculate = remaining;if (next != null) {let scaleMax = Joove.Common.safeNumber(next?.ValueFrom) - Joove.Common.safeNumber(currentScale?.ValueFrom);if (CLMS.Framework.Number.GreaterThan(() => ammoutToCalculate, () => scaleMax)) {ammoutToCalculate = scaleMax;}}total = Joove.Common.safeNumber(total) + Joove.Common.safeNumber(ammoutToCalculate) * Joove.Common.safeNumber((Joove.Common.safeNumber(currentScale?.Value) / Joove.Common.safeNumber(100)));remaining = Joove.Common.safeNumber(remaining) - Joove.Common.safeNumber(ammoutToCalculate);currentScale = next;currentIndex = Joove.Common.safeNumber(currentIndex) + Joove.Common.safeNumber(1);}if (logSection != null) {Domain.TaskLogSection.AddMessage(logSection, Domain.TaskResultMessageSeverity.Info, "Scale result (tiered): " + Joove.Common.safeNumber(total));}return total;}else {for (let _iitem = 0; _iitem < (items?.linq?.skip(1)?.toArray() == null ? 0 : items?.linq?.skip(1)?.toArray().length); _iitem++) {let item = items?.linq?.skip(1)?.toArray()[_iitem];if (CLMS.Framework.Number.GreaterThan(() => item.ValueFrom, () => paramValue)) {return currentScale?.Value;}currentScale = item;}if (logSection != null) {Domain.TaskLogSection.AddMessage(logSection, Domain.TaskResultMessageSeverity.Info, "Scale result: " + Joove.Common.safeNumber(currentScale?.Value));}return currentScale?.Value;}
}
static CalculateValueBasedOnCategory($this: any, payroll: any,logSection: any): any{let allScenarios = Domain.PayrollScaleData.GetActiveSenarios($this, payroll);
let total = 0;
for (let _iscenario = 0; _iscenario < (allScenarios?.linq?.where((s) => CLMS.Framework.Number.GreaterThan(() => s.ParamThree, () => 0))?.toArray() == null ? 0 : allScenarios?.linq?.where((s) => CLMS.Framework.Number.GreaterThan(() => s.ParamThree, () => 0))?.toArray().length); _iscenario++) {let scenario = allScenarios?.linq?.where((s) => CLMS.Framework.Number.GreaterThan(() => s.ParamThree, () => 0))?.toArray()[_iscenario];let paramValue = scenario?.ParamTwo;let originalItems = $this?.Items?.linq?.where((i) => CLMS.Framework.Number.Equal(() => i.PayrollCategory.Id, () => scenario.ParamOne))?.toArray();let full = Domain.PayrollScaleData.CalculateScaleValue($this, paramValue, originalItems, logSection);let daysPerPeriod = Domain.EmployeePayroll.GetDaysPerPeriod(payroll, true);let factor = (CLMS.Framework.Number.Equal(() => daysPerPeriod, () => 0) ? 0 : Joove.Common.safeNumber(scenario?.ParamThree) / Joove.Common.safeNumber(daysPerPeriod));if (CLMS.Framework.Number.GreaterThan(() => factor, () => 1)) {factor = 1;}if (logSection != null) {Domain.TaskLogSection.AddMessage(logSection, Domain.TaskResultMessageSeverity.Info, CLMS.Framework.String.Format("Category: {0}, Level: {1}, Total: {2}, Factor: {3}, Final: {4}", scenario?.ParamOne, scenario?.ParamTwo, full, factor, Joove.Common.safeNumber(full) * Joove.Common.safeNumber(factor)));}total = Joove.Common.safeNumber(total) + Joove.Common.safeNumber((Joove.Common.safeNumber(full) * Joove.Common.safeNumber(factor)));}
return total;
}
static CreateFMYDiscounts($this: any): any{$this.DiscountLimit = 12000;
$this.DiscountLimitReducePercentage = 2;
$this.GeneralDiscountPerChild = 220;
$this?.ChildrenDiscounts?.add({
NumberOfChildren: 0,Discount: 777,}
);
$this?.ChildrenDiscounts?.add({
NumberOfChildren: 1,Discount: 810,}
);
$this?.ChildrenDiscounts?.add({
NumberOfChildren: 2,Discount: 900,}
);
$this?.ChildrenDiscounts?.add({
NumberOfChildren: 3,Discount: 1120,}
);
$this?.ChildrenDiscounts?.add({
NumberOfChildren: 4,Discount: 1340,}
);
}
static GetActiveSenarios($this: any, payroll: any): any{let scenarios = [];
let startDate = payroll?.PayrollCalculation?.Period?.From;
let endDate = payroll?.PayrollCalculation?.Period?.To;
let allCategoriesInRange = payroll?.Contract?.PayrollCategoryHistory?.linq?.orderBy((a) => a?.StartDate)?.toArray();
let totalDays = Domain.EmployeePayroll.GetDaysPerPeriod(payroll, true);
for (let _ientry = 0; _ientry < (allCategoriesInRange == null ? 0 : allCategoriesInRange.length); _ientry++) {let entry = allCategoriesInRange[_ientry];let commonDays = Domain.DateHelper.GetCommonDays(new Date(new Date(entry?.StartDate)?.setHours(0, 0, 0, 0)), new Date(new Date(entry?.EndDate)?.setHours(0, 0, 0, 0)), startDate, endDate);if (CLMS.Framework.Number.Equal(() => commonDays, () => 0)) {continue;}let scenario = new Domain.PayrollCalculationScenarioData();scenario.ParamOne = entry?.PayrollCategory?.Id;scenario.ParamTwo = entry?.Level;scenario.ParamThree = commonDays;scenarios?.add(scenario);totalDays = Joove.Common.safeNumber(totalDays) - Joove.Common.safeNumber(commonDays);}
if (CLMS.Framework.Number.GreaterThan(() => totalDays, () => 0)) {let activeScenario = new Domain.PayrollCalculationScenarioData();activeScenario.ParamOne = payroll?.Contract?.PayrollCategory?.Id;activeScenario.ParamTwo = payroll?.Contract?.PayrollCategoryLevel?.Level;activeScenario.ParamThree = parseInt((totalDays) as any);scenarios?.add(activeScenario);}
return scenarios;
}
static GetClassName(): any{return "PayrollScaleData";
}
static InsertPayrollScaleChildDiscounts($this: any, payrollScaleChildDiscountDTOList: any): any{for (let _ichildDiscountDTO = 0; _ichildDiscountDTO < (payrollScaleChildDiscountDTOList == null ? 0 : payrollScaleChildDiscountDTOList.length); _ichildDiscountDTO++) {let childDiscountDTO = payrollScaleChildDiscountDTOList[_ichildDiscountDTO];let childDiscount = new Domain.PayrollScaleChildDiscount();childDiscount.NumberOfChildren = childDiscountDTO?.NumberOfChildren;childDiscount.Discount = childDiscountDTO?.Discount;$this?.ChildrenDiscounts?.add(childDiscount);}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}